import React, { useEffect } from 'react';
import { useState } from 'react';
import { TextField, Button, Card, CardContent, CardHeader, IconButton, Typography, Dialog, DialogActions, DialogTitle, DialogContent, DialogContentText } from '@material-ui/core';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import SaveIcon from '@material-ui/icons/Save';
import DeleteIcon from '@material-ui/icons/Delete';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import TitleBar from '../Layout/titleBar';
import ColorPicker from './ColorPicker';
import { styles } from './styles';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import { formatMoney } from '../Common/decimalHelper';
import './styles.css';
import { Col, Row } from 'react-flexbox-grid';

const Diseno = ({
    footer,
    menu,
    coloresComponentes,
    login,
    productos,
    emails,
    mediosPago,
    textosGenericos,
    onSave
}) => {
    const classes = styles;

    // States for Footer section
    const [footerLogo, setFooterLogo] = useState(footer.logoFooter || null);
    const [additionalLogo1, setAdditionalLogo1] = useState(footer.logoFooter1 || null);
    const [additionalLogo2, setAdditionalLogo2] = useState(footer.logoFooter2 || null);
    const [facebookLink, setFacebookLink] = useState(footer.facebook || '');
    const [instagramLink, setInstagramLink] = useState(footer.instagram || '');
    const [xLink, setXLink] = useState(footer.twitter || '');
    const [tiktokLink, setTiktokLink] = useState(footer.tiktok || '');
    const [termsFile, setTermsFile] = useState(footer.basesYcondiciones || null);
    const [afipLink, setAfipLink] = useState(footer.afipDataFiscalURL || '');
    const [phone, setPhone] = useState(footer.telefono || '');
    const [email, setEmail] = useState(footer.correo || '');

    // States for Menu section
    const [menuLogo, setMenuLogo] = useState(menu.logoGris || null);
    const [menuLogoPrincipal, setMenuLogoPrincipal] = useState(menu.logoPrincipal || null);

    // States for Login section
    const [logoLoginInterno, setLogoLoginInterno] = useState(login.logoLoginInterno || null);
    const [logoLoginOnline, setLogoLoginOnline] = useState(login.logoLoginOnline || null);

    // States for Icon menu section
    const [iconoMenu, setIconoMenu] = useState(menu.iconoMenu || null);

    // States for Productos section
    const [productLogo, setProductLogo] = useState(productos.logoProducto || null);

    // State for Emails section
    const [emailLogo, setEmailLogo] = useState(emails.logoMail || null);

    // States for Colors
    const [footerPrimaryColor, setFooterPrimaryColor] = useState(footer.colorPrimario || '#ffffff');
    const [footerSecondaryColor, setFooterSecondaryColor] = useState(footer.colorSecundario || '#ffffff');
    const [menuInternoColor, setMenuInternoColor] = useState(menu.superiorInterno || '#ffffff');
    const [menuOnlineColor, setMenuOnlineColor] = useState(menu.superiorOnline || '#ffffff');

    // States for Colors of components
    const [containerTurneroBackground, setContainerTurneroBackground] = useState(coloresComponentes.containerTurneroBackground || '#ffffff');
    const [containerTurneroBorder, setContainerTurneroBorder] = useState(coloresComponentes.containerTurneroBorder || '#ffffff');
    const [containerTurneroItemHorario, setContainerTurneroItemHorario] = useState(coloresComponentes.containerTurneroItemHorario || '#ffffff');
    const [onlineLinksAndButtons, setOnlineLinksAndButtons] = useState(coloresComponentes.onlineLinksAndButtons || '#ffffff');
    const [onlineInformationBoxColor, setOnlineInformationBoxColor] = useState(coloresComponentes.onlineInformationBoxColor || '#f78431');

    // States for Medios de Pago (get and set)
    const [mediosPagoHabilitados, setMediosPagoHabilitados] = useState([]);
    const [mediosPagoNoHabilitados, setMediosPagoNoHabilitados] = useState([]);
    // States for Medios de Pago (deleted images)
    const [eliminadasHabilitadas, setEliminadasHabilitadas] = useState([]);
    const [eliminadasNoHabilitadas, setEliminadasNoHabilitadas] = useState([]);

    //States for delete imgs
    const [eliminarFiles, setEliminarFiles] = useState([]);

    // States for Textos Genéricos section
    const [pickupText, setPickupText] = useState(textosGenericos.pickup || '');
    const [membresiaText, setMembresiaText] = useState(textosGenericos.membresia || '');

    // States for Labels Informativos section
    const [labelDeliveryBonificadoText, setLabelDeliveryBonificadoText] = useState(textosGenericos.deliveryBonificado || 'Delivery bonificado en compras superiores a');
    const [labelFormaPagoText, setLabelFormaPagoText] = useState(textosGenericos.formaPago || 'Para abonar con Billetera Santa Fe, MODO o Mercado Pago, seleccionar la opción');
    const [labelDescripcionPickupText, setLabelDescripcionPickupText] = useState(textosGenericos.descripcionPickup || 'retiro del pedido por sucursal');
    const [labelDescripcionDeliveryText, setLabelDescripcionDeliveryText] = useState(textosGenericos.descripcionDelivery || 'envíos a domicilio');

    // Estados para modal de selección de tipo de medio de pago
    const [openModal, setOpenModal] = useState(false);
    const [tipoMedioPago, setTipoMedioPago] = useState(null);

    // Procesar los medios de pago habilitados y no habilitados
    useEffect(() => {
        // Procesar los medios de pago habilitados de texto
        const habilitadosTexto = mediosPago.habilitados
            ? mediosPago.habilitados.split('.,').map(texto => ({
                tipo: 'texto',
                valor: texto,
                id: `texto-habilitado-${Math.random().toString(36).slice(2, 11)}`,
            }))
            : [];

        // Procesar los medios de pago habilitados de imagen
        const habilitadosImagen = mediosPago.imagenesHabilitados
            ? mediosPago.imagenesHabilitados.map(img => ({
                tipo: 'imagen',
                valor: img.url,
                nombre: img.nombre || (typeof img === 'string' ? img : 'imagen'),
                id: `imagen-habilitado-${Math.random().toString(36).slice(2, 11)}`,
            }))
            : [];

        // Procesar los medios de pago no habilitados de texto
        const noHabilitadosTexto = mediosPago.noHabilitados
            ? mediosPago.noHabilitados.split('.,').map(texto => ({
                tipo: 'texto',
                valor: texto,
                id: `texto-nohabilitado-${Math.random().toString(36).slice(2, 11)}`,
            }))
            : [];

        // Procesar los medios de pago no habilitados de imagen
        const noHabilitadosImagen = mediosPago.imagenesNoHabilitados
            ? mediosPago.imagenesNoHabilitados.map(img => ({
                tipo: 'imagen',
                valor: img.url,
                nombre: img.nombre || (typeof img === 'string' ? img : 'imagen'),
                id: `imagen-nohabilitado-${Math.random().toString(36).slice(2, 11)}`,
            }))
            : [];

        setMediosPagoHabilitados([...habilitadosTexto, ...habilitadosImagen]);
        setMediosPagoNoHabilitados([...noHabilitadosTexto, ...noHabilitadosImagen]);
    }, [mediosPago]);


    const handleAddMedioPago = (tipo) => {
        setTipoMedioPago(tipo); // 'habilitados' o 'noHabilitados'
        setOpenModal(true);
    };

    const handleAddMedioPagoConfirm = (medioTipo) => {
        if (medioTipo === 'texto') {
            const nuevoMedio = {
                tipo: 'texto',
                valor: '',
                id: `texto-${tipoMedioPago}-${Math.random().toString(36).slice(2, 11)}`,
            };
            if (tipoMedioPago === 'habilitados') {
                setMediosPagoHabilitados([...mediosPagoHabilitados, nuevoMedio]);
            } else if (tipoMedioPago === 'noHabilitados') {
                setMediosPagoNoHabilitados([...mediosPagoNoHabilitados, nuevoMedio]);
            }
        } else if (medioTipo === 'imagen') {
            const fileInput = document.createElement('input');
            fileInput.type = 'file';
            fileInput.accept = 'image/*';
            fileInput.onchange = (event) => {
                const file = event.target.files[0];
                if (file) {
                    const nuevoMedio = {
                        tipo: 'imagen',
                        valor: file,
                        nombre: file.name,
                        id: `imagen-${tipoMedioPago}-${Math.random().toString(36).slice(2, 11)}`,
                    };
                    if (tipoMedioPago === 'habilitados') {
                        setMediosPagoHabilitados([...mediosPagoHabilitados, nuevoMedio]);
                    } else if (tipoMedioPago === 'noHabilitados') {
                        setMediosPagoNoHabilitados([...mediosPagoNoHabilitados, nuevoMedio]);
                    }
                }
            };
            fileInput.click();
        }
        setOpenModal(false);
    }

    const handleChangeMedioPago = (id, tipo, valor) => {
        if (tipo === 'habilitados') {
            const updated = mediosPagoHabilitados.map(medio =>
                medio.id === id ? { ...medio, valor } : medio
            );
            setMediosPagoHabilitados(updated);
        } else if (tipo === 'noHabilitados') {
            const updated = mediosPagoNoHabilitados.map(medio =>
                medio.id === id ? { ...medio, valor } : medio
            );
            setMediosPagoNoHabilitados(updated);
        }
    };

    const handleDeleteMedioPago = (id, tipo) => {
        if (tipo === 'habilitados') {
            const medioAEliminar = mediosPagoHabilitados.find(medio => medio.id === id);

            if (medioAEliminar && medioAEliminar.tipo === 'imagen' && typeof medioAEliminar.valor === 'string') {
                setEliminadasHabilitadas([...eliminadasHabilitadas, {
                    nombre: medioAEliminar.nombre,
                    url: medioAEliminar.valor,
                }]);
            }

            const updated = mediosPagoHabilitados.filter(medio => medio.id !== id);
            setMediosPagoHabilitados(updated);
        } else if (tipo === 'noHabilitados') {
            const medioAEliminar = mediosPagoNoHabilitados.find(medio => medio.id === id);

            if (medioAEliminar && medioAEliminar.tipo === 'imagen' && typeof medioAEliminar.valor === 'string') {
                setEliminadasNoHabilitadas([...eliminadasNoHabilitadas, {
                    nombre: medioAEliminar.nombre,
                    url: medioAEliminar.valor,
                }]);
            }

            const updated = mediosPagoNoHabilitados.filter(medio => medio.id !== id);
            setMediosPagoNoHabilitados(updated);
        }
    };

    const handleFileUpload = (setter) => (event) => {
        setter(event.target.files[0]);
    };

    const handleFileRemove = (setter, id) => () => {
        setter(null);
        setEliminarFiles([...eliminarFiles, id]);
    };

    const renderPreview = (file, setter, id) => {
        if (file) {
            if (typeof file === 'string') {
                // Verificar si es archivo PDF
                const isPDF = file.toLowerCase().endsWith('.pdf');
                if (isPDF) {
                    // Extraer nombre del archivo de su URL
                    const fileName = file.split(/[\/\\]/).pop();
                    return (
                        <div style={{ ...classes.previewImageContainer }}>
                            <PictureAsPdfIcon style={{ ...classes.pdfIcon }} />
                            <Typography style={{ color: '#AAA' }} variant="caption" display="block" gutterBottom>
                                <strong>{fileName}</strong>
                            </Typography>
                            <IconButton size="small" style={{ ...classes.deleteButton }} onClick={handleFileRemove(setter, id)}>
                                <DeleteIcon fontSize="small" />
                            </IconButton>
                        </div>
                    )
                } else {
                    // Renderizar como imagen
                    return (
                        <div style={{ ...classes.previewImageContainer }}>
                            <img src={file} alt="Preview" style={{ ...classes.previewImage }} />
                            <IconButton size="small" style={{ ...classes.deleteButton }} onClick={handleFileRemove(setter, id)}>
                                <DeleteIcon fontSize="small" />
                            </IconButton>
                        </div>
                    );
                }
            } else {
                const fileType = file.type || '';
                if (fileType.includes('image')) {
                    return (
                        <div style={{ ...classes.previewImageContainer }}>
                            <img src={URL.createObjectURL(file)} alt="Preview" style={{ ...classes.previewImage }} />
                            <IconButton size="small" style={{ ...classes.deleteButton }} onClick={handleFileRemove(setter, id)}>
                                <DeleteIcon fontSize="small" />
                            </IconButton>
                        </div>
                    );
                } else if (fileType.includes('pdf')) {
                    return (
                        <div style={{ ...classes.previewImageContainer }}>
                            <PictureAsPdfIcon style={{ ...classes.pdfIcon }} />
                            <Typography style={{ color: '#AAA' }} variant="caption" display="block" gutterBottom>
                                <strong>{file.name}</strong>
                            </Typography>
                            <IconButton size="small" style={{ ...classes.deleteButton }} onClick={handleFileRemove(setter, id)}>
                                <DeleteIcon fontSize="small" />
                            </IconButton>
                        </div>
                    );
                }
            }
        }
        return null;
    };

    const createFormData = (data) => {
        const formData = new FormData();

        formData.append('IdInstalacion', data.idInstalacion);

        formData.append('MediosPagoHabilitados', data.mediosPagoHabilitados || '');
        formData.append('MediosPagoNoHabilitados', data.mediosPagoNoHabilitados || '');
        formData.append('EliminarFiles', data.deleteFiles || []);

        if (data.mediosPagoHabilitadosImagenes && data.mediosPagoHabilitadosImagenes.length > 0) {
            data.mediosPagoHabilitadosImagenes.forEach((imagen, index) => {
                if (imagen.archivo) {
                    const imageKey = `MediosPagoHabilitadosImagenes_${imagen.nombre}_${index}`;
                    formData.append(imageKey, imagen.archivo);
                }
            });

            formData.append('MediosPagoHabilitadosImagenesInfo', JSON.stringify(
                data.mediosPagoHabilitadosImagenes.map((imagen) => ({
                    nombre: imagen.nombre,
                    key: imagen.archivo ? `MediosPagoHabilitadosImagenes_${imagen.nombre}_${data.mediosPagoHabilitadosImagenes.indexOf(imagen)}` : null,
                    url: imagen.url,
                }))
            ));
        }

        if (data.mediosPagoNoHabilitadosImagenes && data.mediosPagoNoHabilitadosImagenes.length > 0) {
            data.mediosPagoNoHabilitadosImagenes.forEach((imagen, index) => {
                if (imagen.archivo) {
                    const imageKey = `MediosPagoNoHabilitadosImagenes_${imagen.nombre}_${index}`;
                    formData.append(imageKey, imagen.archivo);
                }
            });

            formData.append('MediosPagoNoHabilitadosImagenesInfo', JSON.stringify(
                data.mediosPagoNoHabilitadosImagenes.map((imagen) => ({
                    nombre: imagen.nombre,
                    key: imagen.archivo ? `MediosPagoNoHabilitadosImagenes_${imagen.nombre}_${data.mediosPagoNoHabilitadosImagenes.indexOf(imagen)}` : null,
                    url: imagen.url,
                }))
            ));
        }

        if (eliminadasHabilitadas.length > 0) {
            formData.append('MediosPagoHabilitadosImagenesEliminadas', JSON.stringify(eliminadasHabilitadas));
        }

        if (eliminadasNoHabilitadas.length > 0) {
            formData.append('MediosPagoNoHabilitadosImagenesEliminadas', JSON.stringify(eliminadasNoHabilitadas));
        }

        if (data.basesYCondiciones instanceof File) {
            formData.append('BasesYCondiciones', data.basesYCondiciones);
        }

        if (data.logoFooter instanceof File) {
            formData.append('LogoFooter', data.logoFooter);
        }

        if (data.logoFooter1 instanceof File) {
            formData.append('LogoFooter1', data.logoFooter1);
        }

        if (data.logoFooter2 instanceof File) {
            formData.append('LogoFooter2', data.logoFooter2);
        }

        if (data.logoProducto instanceof File) {
            formData.append('LogoProducto', data.logoProducto);
        }

        if (data.logoMail instanceof File) {
            formData.append('LogoMail', data.logoMail);
        }

        if (data.logoLogin instanceof File) {
            formData.append('LogoLogin', data.logoLogin);
        }

        if (data.fondoLogin instanceof File) {
            formData.append('FondoLogin', data.fondoLogin);
        }

        if (data.iconoMenu instanceof File) {
            formData.append('IconoMenu', data.iconoMenu);
        }

        if (data.ecommerceGreyscale instanceof File) {
            formData.append('EcommerceGreyscale', data.ecommerceGreyscale);
        }

        if (data.logoDrawer instanceof File) {
            formData.append('LogoDrawer', data.logoDrawer);
        }

        formData.append('DatosContacto', JSON.stringify({
            Email: data.datosContacto?.email || '',
            Telefono: data.datosContacto?.telefono || '',
            Facebook: data.datosContacto?.facebook || '',
            Twitter: data.datosContacto?.twitter || '',
            Instagram: data.datosContacto?.instagram || '',
            TikTok: data.datosContacto?.tiktok || '',
        }));

        formData.append('AfipDataFiscalURL', data.afipDataFiscalURL || '');

        formData.append('TextoGenericoPickup', data.textoGenericoPickup || '');
        formData.append('TextoGenericoMembresia', data.textoGenericoMembresia || '');
        formData.append('LabelDeliveryBonificado', data.labelDeliveryBonificado || '');
        formData.append('LabelFormaPago', data.labelFormaPago || '');
        formData.append('LabelDescripcionPickup', data.labelDescripcionPickup || '');
        formData.append('LabelDescripcionDelivery', data.labelDescripcionDelivery || '');

        return formData;
    }

    const handleSave = () => {
        const mediosHabilitadosTexto = mediosPagoHabilitados
            .filter(medio => medio.tipo === 'texto')
            .map(medio => medio.valor);

        const mediosHabilitadosImagen = mediosPagoHabilitados
            .filter(medio => medio.tipo === 'imagen')
            .map(medio => ({
                nombre: medio.nombre,
                archivo: medio.valor instanceof File ? medio.valor : null,
                url: typeof medio.valor === 'string' ? medio.valor : null,
            }))
            .filter(item => item.archivo || item.url);

        const mediosNoHabilitadosTexto = mediosPagoNoHabilitados
            .filter(medio => medio.tipo === 'texto')
            .map(medio => medio.valor);

        const mediosNoHabilitadosImagen = mediosPagoNoHabilitados
            .filter(medio => medio.tipo === 'imagen')
            .map(medio => ({
                nombre: medio.nombre,
                archivo: medio.valor instanceof File ? medio.valor : null,
                url: typeof medio.valor === 'string' ? medio.valor : null,
            }))
            .filter(item => item.archivo || item.url);

        const instalacionData = {

            datosContacto: {
                email: email,
                telefono: phone,
                facebook: facebookLink,
                twitter: xLink,
                instagram: instagramLink,
                tiktok: tiktokLink,
            },
            idInstalacion: menu.idInstalacion,
            basesYCondiciones: termsFile,
            logoFooter: footerLogo,
            logoFooter1: additionalLogo1,
            logoFooter2: additionalLogo2,
            afipDataFiscalURL: afipLink,
            ecommerceGreyscale: menuLogo,
            logoDrawer: menuLogoPrincipal,
            logoLogin: logoLoginInterno,
            iconoMenu: iconoMenu,
            fondoLogin: logoLoginOnline,
            logoProducto: productLogo,
            logoMail: emailLogo,
            mediosPagoHabilitados: mediosHabilitadosTexto.join('.,'),
            mediosPagoNoHabilitados: mediosNoHabilitadosTexto.join('.,'),
            mediosPagoHabilitadosImagenes: mediosHabilitadosImagen,
            mediosPagoNoHabilitadosImagenes: mediosNoHabilitadosImagen,
            mediosPagohHabilitadosImagenesEliminadas: eliminadasHabilitadas,
            mediosPagohNoHabilitadosImagenesEliminadas: eliminadasNoHabilitadas,
            textoGenericoPickup: pickupText,
            textoGenericoMembresia: membresiaText,
            labelDeliveryBonificado: labelDeliveryBonificadoText,
            labelFormaPago: labelFormaPagoText,
            labelDescripcionPickup: labelDescripcionPickupText,
            labelDescripcionDelivery: labelDescripcionDeliveryText,
            deleteFiles: eliminarFiles,
        };

        const estilosData = {
            internos: {
                topMenuBackgroundcolor: menuInternoColor,
            },
            online: {
                footerBackgroundcolor: footerPrimaryColor,
                footerDesarrolladoPorBackgroundcolor: footerSecondaryColor,
                topMenuBackgroundcolor: menuOnlineColor,
                containerTurneroBackground,
                containerTurneroBorder,
                containerTurneroItemHorario,
                onlineLinksAndButtons,
                onlineInformationBoxColor,
            },
        };

        const formData = createFormData(instalacionData);

        onSave(formData, estilosData);
    };

    return (
        <div>
            <TitleBar title="Diseño" />
            <Card style={{ ...classes.card }}>
                <CardHeader title="Footer" />
                <CardContent style={{ ...classes.gridContainer }}>
                    <div>
                        <Typography variant="h6" style={{ ...classes.sectionHeader }}>Colores</Typography>
                        <div>
                            <ColorPicker currentColor={footerPrimaryColor} onChange={setFooterPrimaryColor} label="Color Principal" />
                        </div>
                        <div style={{ marginTop: '16px' }}>
                            <ColorPicker currentColor={footerSecondaryColor} onChange={setFooterSecondaryColor} label="Color Secundario" />
                        </div>
                    </div>

                    <div>
                        <Typography variant="h6" style={{ ...classes.sectionHeader }}>Imágenes y Archivos</Typography>
                        <div style={{ ...classes.uploadButton }}>
                            <input
                                accept="image/*"
                                style={{ ...classes.inputField }}
                                id="footer-logo-upload"
                                type="file"
                                onChange={handleFileUpload(setFooterLogo)}
                            />
                            <label htmlFor="footer-logo-upload">
                                <Button variant="contained" color="default" component="span" startIcon={<CloudUploadIcon />}>
                                    Cambiar Logo de Footer
                                </Button>
                            </label>
                        </div>
                        {renderPreview(footerLogo, setFooterLogo, 'footer-logo-upload')}

                        <div style={{ ...classes.uploadButton }}>
                            <input
                                accept="image/*"
                                style={{ ...classes.inputField }}
                                id="additional-logo1-upload"
                                type="file"
                                onChange={handleFileUpload(setAdditionalLogo1)}
                            />
                            <label htmlFor="additional-logo1-upload">
                                <Button variant="contained" color="default" component="span" startIcon={<CloudUploadIcon />}>
                                    Cambiar Logo Adicional 1
                                </Button>
                            </label>
                        </div>
                        {renderPreview(additionalLogo1, setAdditionalLogo1, 'additional-logo1-upload')}

                        <div style={{ ...classes.uploadButton }}>
                            <input
                                accept="image/*"
                                style={{ ...classes.inputField }}
                                id="additional-logo2-upload"
                                type="file"
                                onChange={handleFileUpload(setAdditionalLogo2)}
                            />
                            <label htmlFor="additional-logo2-upload">
                                <Button variant="contained" color="default" component="span" startIcon={<CloudUploadIcon />}>
                                    Cambiar Logo Adicional 2
                                </Button>
                            </label>
                        </div>
                        {renderPreview(additionalLogo2, setAdditionalLogo2, 'additional-logo2-upload')}

                        <div style={{ ...classes.uploadButton }}>
                            <input
                                accept=".pdf"
                                style={{ ...classes.inputField }}
                                id="terms-file-upload"
                                type="file"
                                onChange={handleFileUpload(setTermsFile)}
                            />
                            <label htmlFor="terms-file-upload">
                                <Button variant="contained" color="default" component="span" startIcon={<CloudUploadIcon />}>
                                    Cambiar Bases y Condiciones
                                </Button>
                            </label>
                        </div>
                        {renderPreview(termsFile, setTermsFile, 'terms-file-upload')}
                    </div>

                    <div>
                        <Typography variant="h6" style={{ ...classes.sectionHeader }}>Redes Sociales</Typography>
                        <TextField
                            label="Enlace de Facebook"
                            value={facebookLink}
                            onChange={(e) => setFacebookLink(e.target.value)}
                            fullWidth
                            margin="normal"
                        />
                        <TextField
                            label="Enlace de Instagram"
                            value={instagramLink}
                            onChange={(e) => setInstagramLink(e.target.value)}
                            fullWidth
                            margin="normal"
                        />
                        <TextField
                            label="Enlace de X"
                            value={xLink}
                            onChange={(e) => setXLink(e.target.value)}
                            fullWidth
                            margin="normal"
                        />
                        <TextField
                            label="Enlace de TikTok"
                            value={tiktokLink}
                            onChange={(e) => setTiktokLink(e.target.value)}
                            fullWidth
                            margin="normal"
                        />
                    </div>

                    <div>
                        <Typography variant="h6" style={{ ...classes.sectionHeader }}>Contacto</Typography>
                        <TextField
                            label="Enlace de AFIP"
                            value={afipLink}
                            onChange={(e) => setAfipLink(e.target.value)}
                            fullWidth
                            margin="normal"
                        />
                        <TextField
                            label="Número de Teléfono"
                            value={phone}
                            onChange={(e) => setPhone(e.target.value)}
                            fullWidth
                            margin="normal"
                        />
                        <TextField
                            label="Correo Electrónico"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            fullWidth
                            margin="normal"
                        />
                    </div>
                </CardContent>
            </Card>

            {/* Menu Section */}
            <Card style={{ ...classes.card }}>
                <CardHeader title="Header" />
                <CardContent style={{ ...classes.gridContainer }}>
                    <div>
                        <Typography variant="h6" style={{ ...classes.sectionHeader }}>Colores</Typography>

                        <div>
                            <ColorPicker currentColor={menuInternoColor} onChange={setMenuInternoColor} label="Color header backoffice" />
                        </div>
                        <div style={{ marginTop: '16px' }}>
                            <ColorPicker currentColor={menuOnlineColor} onChange={setMenuOnlineColor} label="Color header online" />
                        </div>
                    </div>

                    <div>
                        <Typography variant="h6" style={{ ...classes.sectionHeader }}>Imagenes</Typography>
                        <div style={{ ...classes.uploadButton }}>
                            <input
                                accept="image/*"
                                style={{ ...classes.inputField }}
                                id="menu-logo-upload"
                                type="file"
                                onChange={handleFileUpload(setMenuLogo)}
                            />
                            <label htmlFor="menu-logo-upload">
                                <Button variant="contained" color="default" component="span" startIcon={<CloudUploadIcon />}>
                                    Cambiar logo menu hamburguesa
                                </Button>
                            </label>
                        </div>
                        {renderPreview(menuLogo, setMenuLogo, 'menu-logo-upload')}

                        <div style={{ ...classes.uploadButton }}>
                            <input
                                accept="image/*"
                                style={{ ...classes.inputField }}
                                id="menu-logo-principal-upload"
                                type="file"
                                onChange={handleFileUpload(setMenuLogoPrincipal)}
                            />
                            <label htmlFor="menu-logo-principal-upload">
                                <Button variant="contained" color="default" component="span" startIcon={<CloudUploadIcon />}>
                                    Cambiar logo header
                                </Button>
                            </label>
                        </div>
                        {renderPreview(menuLogoPrincipal, setMenuLogoPrincipal, 'menu-logo-principal-upload')}
                    </div>
                </CardContent>
            </Card>

            {/* Colores de componentes Section */}
            <Card style={{ ...classes.card }}>
                <CardHeader title="Colores de componentes" />
                <CardContent style={{ ...classes.gridContainer }}>
                    <div>
                        <Typography variant="h6" style={{ ...classes.sectionHeader }}>Colores</Typography>

                        {/* Color Picker for container-turnero-background */}
                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
                            <ColorPicker
                                currentColor={containerTurneroBackground}
                                onChange={setContainerTurneroBackground}
                                label="Fondo del turnero"
                            />
                        </div>

                        {/* Color Picker for container-turnero-border */}
                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
                            <ColorPicker
                                currentColor={containerTurneroBorder}
                                onChange={setContainerTurneroBorder}
                                label="Borde del turnero"
                            />
                        </div>

                        {/* Color Picker for container-turnero-item-horario */}
                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
                            <ColorPicker
                                currentColor={containerTurneroItemHorario}
                                onChange={setContainerTurneroItemHorario}
                                label="Item de horario del turnero"
                            />
                        </div>

                        {/* Color Picker for online-links-and-buttons */}
                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
                            <ColorPicker
                                currentColor={onlineLinksAndButtons}
                                onChange={setOnlineLinksAndButtons}
                                label="Links y botones Online"
                            />
                        </div>

                        {/* Color Picker for online-information-box-color */}
                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
                            <ColorPicker
                                currentColor={onlineInformationBoxColor}
                                onChange={setOnlineInformationBoxColor}
                                label="Cuadro de información y Producto sin foto"
                            />
                        </div>
                    </div>
                </CardContent>
            </Card>

            {/* Login Section */}
            <Card style={{ ...classes.card }}>
                <CardHeader title="Login" />
                <CardContent>
                    <div style={{ ...classes.uploadButton }}>
                        <input
                            accept="image/*"
                            style={{ ...classes.inputField }}
                            id="login-logo-interno-upload"
                            type="file"
                            onChange={handleFileUpload(setLogoLoginInterno)}
                        />
                        <label htmlFor="login-logo-interno-upload">
                            <Button variant="contained" color="default" component="span" startIcon={<CloudUploadIcon />}>
                                Cambiar Logo Backoffice
                            </Button>
                        </label>
                    </div>
                    {renderPreview(logoLoginInterno, setLogoLoginInterno, 'login-logo-interno-upload')}

                    <div style={{ ...classes.uploadButton }}>
                        <input
                            accept="image/*"
                            style={{ ...classes.inputField }}
                            id="login-logo-online-upload"
                            type="file"
                            onChange={handleFileUpload(setLogoLoginOnline)}
                        />
                        <label htmlFor="login-logo-online-upload">
                            <Button variant="contained" color="default" component="span" startIcon={<CloudUploadIcon />}>
                                Cambiar Logo Online
                            </Button>
                        </label>
                    </div>
                    {renderPreview(logoLoginOnline, setLogoLoginOnline, 'login-logo-online-upload')}
                </CardContent>
            </Card>
            {/* Icon Menu Principal Section */}
            <Card style={{ ...classes.card }}>
                <CardHeader title="Icono Menu" />
                <CardContent>
                    <div style={{ ...classes.uploadButton }}>
                        <input
                            accept="image/*"
                            style={{ ...classes.inputField }}
                            id="icon-menu-upload"
                            type="file"
                            onChange={handleFileUpload(setIconoMenu)}
                        />
                        <label htmlFor="icon-menu-upload">
                            <Button variant="contained" color="default" component="span" startIcon={<CloudUploadIcon />}>
                                CAMBIAR ICONO DEL MENU PRINCIPAL
                            </Button>
                        </label>
                    </div>
                    {renderPreview(iconoMenu, setIconoMenu, 'icon-menu-upload')}
                </CardContent>
            </Card>
            {/* Productos Section */}
            <Card style={{ ...classes.card }}>
                <CardHeader title="Productos" />
                <CardContent>
                    <div style={{ ...classes.uploadButton }}>
                        <input
                            accept="image/*"
                            style={{ ...classes.inputField }}
                            id="product-logo-upload"
                            type="file"
                            onChange={handleFileUpload(setProductLogo)}
                        />
                        <label htmlFor="product-logo-upload">
                            <Button variant="contained" color="default" component="span" startIcon={<CloudUploadIcon />}>
                                Cambiar Logo de "Producto sin Foto"
                            </Button>
                        </label>
                    </div>
                    {renderPreview(productLogo, setProductLogo, 'product-logo-upload')}
                </CardContent>
            </Card>

            {/* Emails Section */}
            <Card style={{ ...classes.card }}>
                <CardHeader title="Emails" />
                <CardContent>
                    <div style={{ marginBottom: '16px' }}>
                        <input
                            accept="image/*"
                            style={{ ...classes.inputField }}
                            id="email-logo-upload"
                            type="file"
                            onChange={handleFileUpload(setEmailLogo)}
                        />
                        <label htmlFor="email-logo-upload">
                            <Button variant="contained" color="default" component="span" startIcon={<CloudUploadIcon />}>
                                Cambiar Logo de Email
                            </Button>
                        </label>
                    </div>
                    {renderPreview(emailLogo, setEmailLogo, 'email-logo-upload')}
                </CardContent>
            </Card>

            {/* Medios de Pago Section */}
            <Card style={{ ...classes.card }}>
                <CardHeader title="Medios de Pago" />
                <CardContent style={{ ...classes.gridContainer }}>
                    {/* Medios de Pago Habilitados */}
                    <div>
                        <Typography variant="subtitle1">Medios de Pago Habilitados</Typography>
                        {mediosPagoHabilitados.map((medio) => (
                            <div key={medio.id} style={{ ...classes.medioPagoContainer }}>
                                {medio.tipo === 'texto' ? (
                                    <TextField
                                        label={`Medio Habilitado`}
                                        value={medio.valor}
                                        onChange={(e) => handleChangeMedioPago(medio.id, 'habilitados', e.target.value)}
                                        fullWidth
                                        margin="normal"
                                    />
                                ) : (
                                    <div style={{ ...classes.previewImageContainer }}>
                                        {typeof medio.valor === 'string' ? (
                                            <img src={medio.valor} alt={medio.nombre} style={{ ...classes.previewImage }} />
                                        ) : (
                                            <img src={URL.createObjectURL(medio.valor)} alt={medio.nombre} style={{ ...classes.previewImage }} />
                                        )}
                                        <Typography variant="caption">{medio.nombre}</Typography>
                                    </div>
                                )}
                                <IconButton onClick={() => handleDeleteMedioPago(medio.id, 'habilitados')}>
                                    <DeleteIcon />
                                </IconButton>
                            </div>
                        ))}
                        <Button onClick={() => handleAddMedioPago('habilitados')} variant="contained" color="primary">
                            Añadir Medio Habilitado
                        </Button>
                    </div>

                    {/* Medios de Pago No Habilitados */}
                    <div>
                        <Typography variant="subtitle1">Medios de Pago No Habilitados</Typography>
                        {mediosPagoNoHabilitados.map((medio) => (
                            <div key={medio.id} style={{ ...classes.medioPagoContainer }}>
                                {medio.tipo === 'texto' ? (
                                    <TextField
                                        label={`Medio No Habilitado`}
                                        value={medio.valor}
                                        onChange={(e) => handleChangeMedioPago(medio.id, 'noHabilitados', e.target.value)}
                                        fullWidth
                                        margin="normal"
                                    />
                                ) : (
                                    <div style={{ ...classes.previewImageContainer }}>
                                        {typeof medio.valor === 'string' ? (
                                            <img src={medio.valor} alt={medio.nombre} style={{ ...classes.previewImage }} />
                                        ) : (
                                            <img src={URL.createObjectURL(medio.valor)} alt={medio.nombre} style={{ ...classes.previewImage }} />
                                        )}
                                        <Typography variant="caption">{medio.nombre}</Typography>
                                    </div>
                                )}
                                <IconButton onClick={() => handleDeleteMedioPago(medio.id, 'noHabilitados')}>
                                    <DeleteIcon />
                                </IconButton>
                            </div>
                        ))}
                        <Button onClick={() => handleAddMedioPago('noHabilitados')} variant="contained" color="primary">
                            Añadir Medio No Habilitado
                        </Button>
                    </div>
                    {/* <div>
                        <Typography variant="subtitle1">Imagen de Medios de Pago</Typography>
                        <div style={{...classes.uploadButton}}>
                            <input
                                accept="image/*"
                                style={{...classes.inputField}}
                                id="medios-pago-image-upload"
                                type="file"
                                onChange={handleFileUpload(setMediosPagoImage)}
                            />
                            <label htmlFor="medios-pago-image-upload">
                                <Button variant="contained" color="default" component="span" startIcon={<CloudUploadIcon />}>
                                    Cambiar imagen de medios de pago
                                </Button>
                            </label>
                        </div>
                        {renderPreview(mediosPagoImage, setMediosPagoImage)}    
                    </div> */}
                </CardContent>
            </Card>

            {/* Textos Genéricos Section */}
            <Card style={{ ...classes.card }}>
                <CardHeader title="Textos Genéricos" />
                <CardContent style={{ ...classes.gridContainer }}>
                    <div>
                        <Typography variant="h6" style={{ ...classes.sectionHeader }}>Formas de entrega</Typography>
                        <TextField
                            label={`Texto de 'Pick up'`}
                            value={pickupText}
                            onChange={(e) => setPickupText(e.target.value)}
                            fullWidth
                            margin="normal"
                        />
                    </div>
                    <div>
                        <Typography variant="h6" style={{ ...classes.sectionHeader }}>Membresías y Beneficios</Typography>
                        <TextField
                            label={`Texto de Membresías`}
                            value={membresiaText}
                            onChange={(e) => { setMembresiaText(e.target.value) }}
                            fullWidth
                            margin="normal"
                        />
                    </div>
                </CardContent>
            </Card>

            {/* Labels Informativos Section */}
            <Card style={{ ...classes.card }}>
                <CardHeader title="Labels Informativos" />
                <CardContent style={{ ...classes.gridContainer }}>
                    <div>
                        <Typography variant="h6" style={{ ...classes.sectionHeader }}>Delivery bonificado</Typography>
                        <TextField
                            label={`Texto de 'Delivery bonificado'`}
                            value={labelDeliveryBonificadoText}
                            onChange={(e) => setLabelDeliveryBonificadoText(e.target.value)}
                            fullWidth
                            margin="normal"
                        />
                        <div className="diaNoLaborable" style={{
                            margin: '10px 8% 10px',
                            display: 'flex',
                            alignItems: 'center',
                            background: '#fde0cb',
                            padding: '20px',
                            borderRadius: '16px',
                            color: '#f78431',
                            font: '600 14px/18px Poppins',
                            letterSpacing: '0px',
                            opacity: 1,
                            gap: '10px',
                        }}>
                            <InfoOutlinedIcon />
                            <div>{labelDeliveryBonificadoText} {formatMoney(15000)}</div>
                        </div>
                    </div>
                    <div>
                        <Typography variant="h6" style={{ ...classes.sectionHeader }}>Forma de pago</Typography>
                        <TextField
                            label={`Texto de 'Forma de pago'`}
                            value={labelFormaPagoText}
                            onChange={(e) => setLabelFormaPagoText(e.target.value)}
                            fullWidth
                            margin="normal"
                        />
                        <div className="infoFormaPagos" style={{
                            margin: '10px 8% 10px',
                            display: 'flex',
                            alignItems: 'center',
                            background: '#e0f7fa',
                            padding: '20px',
                            borderRadius: '16px',
                            color: '#00796b',
                            font: '600 14px/18px Poppins',
                            letterSpacing: '0px',
                            opacity: 1,
                            gap: '10px',
                        }}>
                            <InfoOutlinedIcon />
                            <div>{`${labelFormaPagoText}: Pago al recibir.`}</div>
                        </div>
                    </div>
                    <div>
                        <Typography variant="h6" style={{ ...classes.sectionHeader }}>Descripción de Pick-up</Typography>
                        <TextField
                            label={`Texto de 'Descripción de Pick-up'`}
                            value={labelDescripcionPickupText}
                            onChange={(e) => setLabelDescripcionPickupText(e.target.value)}
                            fullWidth
                            margin="normal"
                        />
                        <div className="infoDescripcionPickup" style={{
                            margin: '10px 8% 10px',
                            display: 'flex',
                            alignItems: 'center',
                            background: '#f5f5f5',
                            padding: '20px',
                            borderRadius: '16px',
                            color: '#555555',
                            font: '400 14px/18px Poppins',
                            letterSpacing: '0px',
                            opacity: 1,
                            gap: '10px',
                        }}>
                            <div style={{
                                fontFamily: 'Poppins',
                                fontWeight: 400,
                                fontSize: '16px',
                                lineHeight: '24px',
                                color: '#555555'
                            }}>
                                Pick-up: {labelDescripcionPickupText}.
                            </div>
                        </div>
                    </div>
                    <div>
                        <Typography variant="h6" style={{ ...classes.sectionHeader }}>Descripción de Delivery</Typography>
                        <TextField
                            label={`Texto de 'Descripción de Delivery'`}
                            value={labelDescripcionDeliveryText}
                            onChange={(e) => setLabelDescripcionDeliveryText(e.target.value)}
                            fullWidth
                            margin="normal"
                        />
                        <div className="infoDescripcionDelivery" style={{
                            margin: '10px 8% 10px',
                            display: 'flex',
                            alignItems: 'center',
                            background: '#f5f5f5',
                            padding: '20px',
                            borderRadius: '16px',
                            color: '#555555',
                            font: '400 14px/18px Poppins',
                            letterSpacing: '0px',
                            opacity: 1,
                            gap: '10px',
                        }}>
                            <div style={{
                                fontFamily: 'Poppins',
                                fontWeight: 400,
                                fontSize: '16px',
                                lineHeight: '24px',
                                color: '#555555'
                            }}>
                                Delivery: {labelDescripcionDeliveryText}.
                            </div>
                        </div>
                    </div>
                </CardContent>
            </Card>

            {/* Dialog for selecting payment method type */}
            <Dialog
                classes={{ root: classes.rootDialog, paperScrollPaper: classes.root }}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth='sm'
                fullWidth={true}
                open={openModal}
                onClose={() => setOpenModal(false)}
            >
                <DialogContent classes={{ root: classes.root }}>
                    <Row style={{ margin: '0px' }}>
                        <Col xs={12} md={12} lg={12} style={{ padding: '0px' }}>

                            <div className='containerModalEdicion'>
                                <div className='containerModalTipoMedioPago'>
                                    <div className='labelTitle'>
                                        Tipo de medio de pago
                                    </div>
                                    <div className='textoContenido'>
                                        Por favor, seleccione el tipo de medio de pago que desea agregar
                                    </div>
                                    <div className='containerButtonsModal' style={{ marginTop: '16px', display: 'flex', justifyContent: 'space-around' }}>
                                        <Button
                                            className='btnTextoModal'
                                            onClick={() => handleAddMedioPagoConfirm('texto')}
                                        >
                                            Texto
                                        </Button>
                                        <Button
                                            className='btnImagenModal'
                                            onClick={() => handleAddMedioPagoConfirm('imagen')}
                                        >
                                            Imagen
                                        </Button>
                                    </div>
                                </div>
                            </div>

                        </Col>
                    </Row>
                </DialogContent>
            </Dialog>

            {/* Save Button */}
            <div style={{ ...classes.saveButtonContainer }}>
                <Button variant="contained" color="primary" startIcon={<SaveIcon />} onClick={handleSave} style={{ ...classes.saveButton }}>
                    Guardar
                </Button>
            </div>
        </div>
    );
};

export default Diseno;
